// write home page here
const Achievements = () => {
    return (
        <div>
        <h1>Achievements Page</h1>
        </div>
    );
}
export default Achievements;